package com.xtream.video_player.util

enum class ProjectContentScale {
    Fit,
    Crop,
    FillBounds,
    None
}